import './polyfill-prepend.js'
let _stickyHelper = document.createElement("div")

export default {
  bind: function (el, binding, vnode) {
    let _stickyContainer
    let isSticky = false
    let lastScrollTop = 0

    const onScroll = (isFixed) => {
      window.addEventListener('scroll', () => {
        let parentElTop = el.parentElement.getBoundingClientRect().top

        if (parentElTop < 0 && !isSticky) {
          isSticky = true
          el.classList.add("sticky")

          if (!isFixed) {
            _stickyContainer.style.position = 'fixed'
          }

        } else if (parentElTop >= 0 && isSticky) {
          isSticky = false
          el.classList.remove("sticky")

          if (!isFixed) {
            _stickyContainer.style.position = 'absolute'
          }
        }

        let st = window.pageYOffset || document.documentElement.scrollTop

        if (isSticky && st - lastScrollTop > 30) {
          el.classList.add("unpinned")
        } else if (isSticky && st - lastScrollTop < 0) {
          el.classList.remove("unpinned")
        }

        lastScrollTop = st <= 0 ? 0 : st

      }, {
        passive: false
      })
    }

    const onResize = () => {
      window.addEventListener("resize", () => {
        _stickyHelper.style.height = `${el.children[1].offsetHeight - parseInt(getComputedStyle(el).paddingTop)}px`
      }, {
        passive: false
      })
    }

    const initFixedElement = () => {
      _stickyHelper.style.cssText = `height:${el.offsetHeight - parseInt(getComputedStyle(el).paddingTop)}px;position:relative;`

      _stickyContainer = el.children[0]
      el.prepend(_stickyHelper)

      _stickyContainer.style.cssText = `position:absolute;padding-top:${getComputedStyle(el).paddingTop};padding-left:${getComputedStyle(el).paddingLeft};padding-right:${getComputedStyle(el).paddingRight};left:0;right:0;top:0;`

      onScroll()

      onResize()
    }

    window.addEventListener('load', () => {
      if (getComputedStyle(el).position !== 'fixed') {
        initFixedElement()
      } else {
        _stickyHelper = null
        onScroll(true)
      }
    })
  }
}